import Axios from "axios";

const CWEstimatePrinter = (receiptData) => {
  const storedTokenData = localStorage.getItem("tokenData") ? JSON.parse(localStorage.getItem("tokenData")) : {};
  const lastDate = storedTokenData.date || "";
  const tillData = JSON.parse(localStorage.getItem("tillData"));

  const processTokenTemplate = (template, data) => {
    const processedTemplate = JSON.parse(JSON.stringify(template));
    processedTemplate.elements = processedTemplate.elements.flatMap((element) => {
      if (element.type === "conditional" && element.condition && element.elements) {
        const conditionResult = evaluateCondition(element.condition, data);
        if (conditionResult) {
          return element.elements.flatMap((nestedElement) => processTokenTemplate({ elements: [nestedElement] }, data).elements);
        }
        return [];
      }
      if (element.type === "text" && element.content && typeof element.content === "string") {
        element.content = replacePlaceholders(element.content, data);
      }
      if (element.type === "qrcode" && element.content) {
        element.content = replacePlaceholders(element.content, data);
      }
      if (element.type === "loop" && element.data && typeof element.data === "string") {
        const loopDataPath = element.data.replace(/{{|}}/g, "");
        const loopData = getDeepValue(data, loopDataPath) || [];
        if (Array.isArray(loopData)) {
          return loopData.flatMap((loopItem) => {
            return element.elements.flatMap((loopElement) => {
              const newElement = JSON.parse(JSON.stringify(loopElement));
              if (newElement.type === "text" && newElement.content && typeof newElement.content === "string") {
                newElement.content = replacePlaceholders(newElement.content, loopItem);
              }
              return newElement;
            });
          });
        }
        return [];
      }
      return element;
    });
    return processedTemplate;
  };

  const evaluateCondition = (condition, data) => {
    try {
      const resolvedCondition = condition.replace(/{{([^}]+)}}/g, (match, placeholder) => {
        const value = getDeepValue(data, placeholder);
        return value !== undefined ? JSON.stringify(value) : "undefined";
      });
      return eval(resolvedCondition);
    } catch (error) {
      console.error("Error evaluating condition:", condition, error);
      return false;
    }
  };

  const replacePlaceholders = (text, data) => {
    return text.replace(/{{([^}]+)}}/g, (match, placeholder) => {
      const value = getDeepValue(data, placeholder);
      return value !== undefined ? value : "";
    });
  };

  const getDeepValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : null), obj);
  };

  const printToken = (receiptData) => {
    const tillData = JSON.parse(localStorage.getItem("tillData"));
    const printerURL = tillData.tillAccess.cwrTill.hardwareController.imageUrl;
    const productSkuValue = receiptData.items.map((item) => {
      if (item.uomData[0].decimal === "Y") {
        return (
          5 +
          item?.value.toString().padStart(6, "0").slice(0, 6) +
          Math.round(item?.weight * 10000)
            .toString()
            .padStart(6, "0")
        );
      } else {
        return (
          8 +
          item?.value.toString().padStart(6, "0").slice(0, 6) +
          Math.round(item?.weight * 10)
            .toString()
            .padStart(6, "0")
        );
      }
    });

    const barcode = productSkuValue.join(" ");
    const printData = {
      productionCenter: "Estimate",
      saleType: receiptData?.saleType?.name || "Walk-in",
      orderDate: receiptData?.orderDate || new Date().toISOString().split("T")[0],
      documentno: receiptData?.documentno,
      items:
        receiptData?.items?.map((item) => ({
          name: item.name,
          weight: item.weight,
        })) || [],
      qrcode: barcode, // Pass the formatted string
    };
    // Process template
    const processedToken = processTokenTemplate(JSON.parse(tillData.tillAccess.cwrTill.kotPrintTemplate.xmlcode2), printData);

    // Update QR code content in the processed template
    processedToken.elements = processedToken.elements.map((element) => {
      if (element.type === "qrcode") {
        return {
          ...element,
          content: barcode, // Set QR code content
        };
      }
      return element;
    });

    Axios.post(`${printerURL}printer`, JSON.stringify(processedToken), {
      headers: { "Content-Type": "application/json" }, // Recommended content type
    })
      .then((response) => console.log("Print success:", response))
      .catch((error) => console.error("Print error:", error));
  };
  if (tillData?.tillAccess?.cwrTill?.kotPrintTemplate?.xmlcode2) {
    // Call printToken for each vendor with the same bill token
    printToken(receiptData);
  }

  return receiptData;
};

export default CWEstimatePrinter;
